module.exports = __webpack_public_path__ + "img/img08.e2f664b8.png";